import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { Button, ListInfoGlyph } from "@atoms"

import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import styles from "@organisms/ObjectsView/TableView/TableViewEdgeStates/TableViewEdgeStates.module.scss"
import TableViewLoadingState from "@organisms/ObjectsView/TableView/TableViewEdgeStates/TableViewLoadingState/TableViewLoadingState"

import { CLEAR_SEARCH_EVENT } from "@constants/events"

import { TableViewNoResultsStateProps } from "./TableViewNoResultsState.types"

export default function TableViewNoResultsState(props: TableViewNoResultsStateProps) {
    const { children } = props

    const { tabContentName } = useObjectsView()

    const isDesktop = useIsDesktop()

    const explanation = `There are no ${tabContentName
        .toLowerCase()
        .replace("all", "")
        .replace("&", "or")} to display.`

    return (
        <>
            {children}
            <div className={styles.base}>
                <TableViewLoadingState isAnimated={false} isBackground={true} numberOfRows={isDesktop ? 4 : 2} />
                <div className={styles.content}>
                    <div className={styles.copyWrap}>
                        <ListInfoGlyph variant="black" icon={faIcon({ name: "eye", style: "solid" })} />
                        <div className={styles.copy}>
                            <h2 className={styles.title}>No results found</h2>
                            <p className={styles.explanation}>{explanation}</p>
                        </div>
                    </div>

                    <Button
                        size="lg"
                        variant="subtle"
                        onClick={() => {
                            const clearSearchEvent = new CustomEvent(CLEAR_SEARCH_EVENT, {})
                            window.dispatchEvent(clearSearchEvent)
                        }}
                        noDebounce={true}
                    >
                        Clear search
                    </Button>
                </div>
            </div>
        </>
    )
}
